<template>
  <v-container fluid grid-list-md>
    <v-layout row justify-center align-center>
      <v-flex md8 xs12>
        <eimza-gate title="Excel İle Gelişmiş SMS">
          <v-alert style="overflow-x: auto;margin: 0 10px;" type="warning">
            <span>
              HATIRLATMA!
              <br>
              Ticari SMS içeriklerinde;
              firmalar için Mersis No, şahıs işletmelerinde ise;
              Ad Soyad ve TC.Kimlik Numarası, telefon veya email gibi iletişim bilgisinin
              RET Hizmeti ile birlikte bulunması önem teşkil etmektedir.
            </span>
          </v-alert>
          <v-card-text>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1">Excel Dosya Seçimi</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">SMS'i Hazırla</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <!-- STEP 1 -->
                <v-stepper-content step="1">
                  <v-card elevation="0">
                    <v-card-text>
                      <v-form ref="stepOne" lazy-validation>
                        <v-file-input
                          placeholder="SMS gönderilecek Excel dosyanızı seçiniz"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          v-model="files"
                          :rules="[$rules.required({ falseValues: [null], message: 'Bir dosya yüklemelisiniz' })]"
                          chips
                          required
                          prepend-icon="mdi-paperclip"
                        ></v-file-input>
                      </v-form>
                    </v-card-text>
                    <v-card-actions class="justify-space-between">
                      <ExcelButton type="advanced"></ExcelButton>
                      <v-btn color="primary" :loading="loading" @click="stepper">İleri</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
                <!-- STEP 2 -->
                <v-stepper-content step="2">
                  <v-card v-if="e1 === 2" elevation="0">
                    <v-card-text class="pa-0">
                      <v-form ref="stepTwo" lazy-validation>
                        <v-layout row wrap>
                          <v-flex md8 xs12>
                            <v-btn
                              v-for="(header, key) in stepOneResponse.headers"
                              :key="key"
                              class="mr-2"
                              outlined
                              v-text="header"
                              @click="messageType(header)"
                            ></v-btn>
                            <button-keys
                              :keys="stepOneResponse.keys"
                              item-value="value"
                              @on:button-key="(val) => { this.sendData.message += ` ${val}`; }"
                            ></button-keys>
                            <div v-if="preview"><b>Önizleme: </b> {{preview}}</div>
                            <sms-message
                              label="Mesajınız"
                              class="pt-0"
                              :value="sendData.message"
                              :c-message="sendData.message"
                              :c-type="sendData.message_type"
                              :rules="[
                                $rules.empty('Mesaj'),
                                (v) => sendData.message_type === 'turkce' ? v.length <= 877 || 'Maksimum karakter sayısı 882 olabilir.' : sendData.message_type === 'normal' || true,
                              ]"
                              rows="14"
                              @text:change="handleTextChange"
                            ></sms-message>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-flex xs12>
                              <v-select
                                v-model="sendData.phone_colon"
                                label="Telefon Adı Alanını Seçiniz."
                                required
                                :rules="[$rules.selection('Telefon Adı'), () => !!sendData.phone_colon || 'Telefon Adı alanı gereklidir.']"
                                :items="eHeaders"
                                item-value="k"
                                item-text="v"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12>
                              <senders-or-message-types
                                label="Gönderici Adları"
                                no-data-text="Aktif Gönderici Adı bulunmuyor"
                                :items="stepOneResponse.senders"
                                :default="stepOneResponse.senders[0]"
                                :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderici adı seçimi yapmalısınız' })]"
                                required
                                @on:model-update="(val) => { sendData.sender = val; }"
                              ></senders-or-message-types>
                            </v-flex>
                            <v-flex xs12>
                              <senders-or-message-types
                                label="Tür"
                                :items="types"
                                :rules="[$rules.required({ falseValues: [undefined, null], message: 'Mesaj türü seçimi yapmalısınız' })]"
                                :default="stepOneResponse.default_message_type"
                                item-text="text"
                                item-value="value"
                                @on:model-update="(val) => { sendData.message_type = val; }"
                              ></senders-or-message-types>
                            </v-flex>
                            <v-flex xs12>
                              <template-selector
                                label="Şablon Seçinizi"
                                :items="stepOneResponse.templates"
                                @on:template-selected="(val) => { sendData.message = val.content; }"
                              ></template-selector>
                            </v-flex>
                            <v-flex xs12>
                              <time-type
                                :rules="[$rules.required({ falseValues: [undefined, null], message: 'Gönderim zamanı seçimi yapmalısınız' })]"
                                @type:update="(val) => (wTimeStat = val)"
                              ></time-type>
                            </v-flex>
                            <v-flex xs12 v-if="wTimeStat">
                              <date-month-picker
                                label="Gönderme Tarihi"
                                :disable-prev="true"
                                :rules="[$rules.required({ falseValues: [''], message: 'Tarih seçimi yapmalısınız' })]"
                                @on:date-selected="(val) => { date = val; dateSelected = true; }"
                              ></date-month-picker>
                            </v-flex>
                            <v-flex xs12 v-if="wTimeStat">
                              <time-picker
                                label="Gönderme Saati"
                                :valid="dateSelected"
                                :rules="[$rules.empty('Gönderme Saati')]"
                                @on:time-selected="(val) => { time = ` ${val}:00`; }"
                              ></time-picker>
                            </v-flex>
                            <v-flex xs12 v-if="$store.state.iys_status === 1">
                              <message-type @type="(val) => (sendData.message_content_type = val)"></message-type>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                        <v-card-actions class="justify-space-between">
                          <v-btn type="text" @click="e1 = 1">Geri</v-btn>
                          <v-btn color="primary" @click="smsPreview">
                            Mesajı Gönder <v-icon right dark>mdi-send</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
        </eimza-gate>
      </v-flex>
    </v-layout>
    <sms-confirmation
      :title="confirmation.title"
      :context="confirmation.context"
      :valid="confirmation.valid"
      @on:disagree="() => { $trigger('setPluginDialog'); confirmation.valid = !confirmation.valid; }"
      @on:agree="sendSMSS2"
    ></sms-confirmation>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../../../misc';
import EimzaGate from '../../../Components/EimzaGate.vue';
import DateMonthPicker from '../../../Components/SMSConstants/DateMonthPicker.vue';
import TimePicker from '../../../Components/SMSConstants/TimePicker.vue';
import SendersOrMessageTypes from '../../../Components/SMSConstants/SendersOrMessageTypes.vue';
import SmsMessage from '../../../Components/SMSConstants/SmsMessage.vue';
import TimeType from '../../../Components/SMSConstants/TimeType.vue';
import ExcelButton from '../../../Components/Sms/ExcelButton.vue';
import ButtonKeys from '../../../Components/SMSConstants/ButtonKeys.vue';
import SmsConfirmation from '../../../Components/SMSConfirmation.vue';
import TemplateSelector from '../../../Components/SMSConstants/TemplateSelector.vue';
import MessageType from '../../../Components/SMSConstants/MessageType.vue';

export default {
  name: 'AdvancedExcel',
  components: {
    EimzaGate,
    TemplateSelector,
    SmsConfirmation,
    ButtonKeys,
    TimeType,
    SmsMessage,
    SendersOrMessageTypes,
    TimePicker,
    DateMonthPicker,
    ExcelButton,
    MessageType,
  },
  data: () => ({
    loading: false,
    types,
    e1: 1,
    wTimeStat: false,
    dateSelected: false,
    preview: '',
    time: '',
    date: '',
    stepOneResponse: [],
    sendData: { message: '', message_type: null },
    confirmation: { valid: false, context: { examples: [] } },
    files: null,
    freeze: [],
    sizeRule: [v => v.size > 0 || 'Bir Dosya Yüklemelisiniz!'],
    senders: [],
  }),
  computed: {
    eHeaders() {
      const rHeaders = [];
      Object.entries(this.stepOneResponse.headers).forEach((v) => {
        rHeaders.push({ k: v[0], v: v[1] });
      });
      return rHeaders;
    },
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    messageType(val) {
      this.sendData.message += `|${val}| `;
      let i = null;
      Object.entries(this.stepOneResponse.exampleValues)
        // eslint-disable-next-line array-callback-return
        .filter((el) => { if (el[0] === val) { i = el[1]; } });
      this.preview += `${i} `;
    },
    stepper() {
      if (this.e1 === 0 || this.e1 === 1) {
        if (this.$refs.stepOne.validate()) { this.uploadFileS1(); this.preview = ''; }
      } else if (this.$refs.stepTwo.validate()) {
        this.sendSMSS2();
      }
    },
    uploadFileS1() {
      const form = new FormData();
      form.append('excel', this.files);
      this.loading = true;
      if (this.$refs.stepOne.validate()) {
        this.send({ route: 'sms/excel', data: form, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(async (res) => {
            this.stepOneResponse = await res.data.data;
            if (this.stepOneResponse.senders === null) this.stepOneResponse.senders = [];
            this.e1 = 2;
            const allowedKeys = ['İptal Linki', 'Kısa Kod'];
            this.stepOneResponse.keys = Object.filterByKey(allowedKeys, this.stepOneResponse.keys);
          })
          .finally(() => { this.loading = false; });
      }
    },
    sendSMSS2() {
      if (this.$refs.stepTwo.validate()) {
        this.prepareOriginal();
        this.send({ route: 'sms/excel/send', data: this.sendData })
          .then(() => { this.resetForm(); this.e1 = 1; });
      }
    },
    handleTextChange(val) {
      this.sendData.message = val || '';
      const keys = this.stepOneResponse.exampleValues;
      let dumpPreview = this.sendData.message;
      if (dumpPreview) {
        Object.keys(keys).forEach((exVal) => {
          dumpPreview = dumpPreview.replace(`|${exVal}|`, keys[exVal]);
        });
      }
      this.preview = dumpPreview;
    },
    smsPreview() {
      if (this.confirmation.valid) {
        this.confirmation.valid = false;
        this.$trigger('setPluginDialog');
      }
      this.confirmation.valid = this.$refs.stepTwo.validate();
      if (this.$refs.stepTwo.validate()) {
        this.prepareOriginal();
        this.send({ route: 'sms/excel/send/preview', data: this.sendData })
          .then((res) => { this.confirmation.context = res.data.data; });
      }
    },
    prepareOriginal() {
      this.sendData.excel = this.stepOneResponse.file;
      this.sendData.send_time = this.date + this.time;
      if (!this.wTimeStat) delete this.sendData.send_time;
    },
    resetForm() {
      this.$refs.stepOne.reset();
      this.$refs.stepTwo.reset();
      this.wTimeStat = false;
    },
  },
};
</script>
